import React, { useContext } from "react";
import "./Navbar.css";
import Link from "next/link";
import { UserContext } from "@/context/ContextProvider";
import carIcon from "@/assets/Navbar/carIcon.svg";
import doorIcon from "@/assets/Navbar/doorIcon.svg";
import { auth } from "@/config/firebaseConfig"; // Import Firebase Auth
import { signOut } from "firebase/auth"; // Import signOut
import closeIcon from "@/assets/icons/closeBlack.svg";
import Image from "next/image";
import { useAsyncRoutePush } from "@/app/helpers/useAsyncRoutePush";

function SidebarLeft({ isSidebarLeftOpen, setIsSidebarLeftOpen }) {
  const { userData } = useContext(UserContext); // Consume the context

  const asyncPush = useAsyncRoutePush();

  const handleSignOut = async () => {
    try {
      await asyncPush("/");
      await signOut(auth); // Sign out the user
      setIsSidebarLeftOpen(false);
    } catch (error) {
      console.error("Error signing out:", error);
      alert("Fehler beim Abmelden. Bitte versuchen Sie es erneut.");
    }
  };

  return (
    <div
      className={`sidebarLeft ${isSidebarLeftOpen ? "open" : ""} `}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="Sidebar-wrapper">
        <Image
          src={closeIcon}
          alt="Schließen"
          className="SidebarLeft-close"
          onClick={() => setIsSidebarLeftOpen(false)}
        />
        <ul className="nav-links">
          {userData ? (
            <>
              <li onClick={() => setIsSidebarLeftOpen(false)}>
                <Image
                  src={carIcon}
                  alt="carIcon"
                  className="konto-dropdown-icon"
                />

                <Link href="/account" className="links">
                  Account
                </Link>
              </li>

              <li onClick={() => handleSignOut()}>
                <Image
                  src={doorIcon}
                  alt="signOut"
                  className="konto-dropdown-icon"
                />

                <span className="links">Ausloggen</span>
              </li>
            </>
          ) : (
            <li onClick={() => setIsSidebarLeftOpen(false)}>
              <Link href="/anmelden" className="links">
                Anmelden
              </Link>
            </li>
          )}
        </ul>
      </div>
    </div>
  );
}

export default SidebarLeft;
